import { render, staticRenderFns } from "./ExpiringPointLogs.vue?vue&type=template&id=dbeaa7c0&scoped=true&"
import script from "./ExpiringPointLogs.vue?vue&type=script&lang=js&"
export * from "./ExpiringPointLogs.vue?vue&type=script&lang=js&"
import style0 from "./ExpiringPointLogs.vue?vue&type=style&index=0&id=dbeaa7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbeaa7c0",
  null
  
)

export default component.exports